import moment from "moment";

export const getToken = () => {
  return localStorage.getItem("accessToken");
};

export const getUserRole = () => {
  return localStorage.getItem("userRole")
} 

// Date string with timestamp to DD-MM-YYYY HH:mm format
export const formatDate = (date) => {
  const formattedDate = moment(date).format("DD-MM-YYYY hh:mm A");
  return date?.length > 0 ? formattedDate : "-";
};
